// @ts-nocheck

import * as React from 'react';
import { Link } from '../components/core';
const TIMEZONE_DOCS = 'https://docs.branch.io/pages/dashboard/timezone/';
const SETTING_TOP_COPY = <span>Set your dashboard's time zone for consistent reporting, no matter where you are. </span>;
const CHANGING_TOP_COPY = (
  <span>
    Your time zone affects your dashboard analytics and how your Branch data matches up with external data sources like
    Facebook. Changing time zone may cause inconsistencies when compared to previously generated reports or external data
    sources.{' '}
  </span>
);

const _getTimezoneCopy = (topCopy) => (
  <div className="h_fw-400">
    {topCopy}
    <Link href={TIMEZONE_DOCS} testid="timezone_learn-more">
      Learn More
    </Link>
    <span>.</span>
  </div>
);

export const SETTING_TIMEZONE_COPY = _getTimezoneCopy(SETTING_TOP_COPY);
export const CHANGING_TIMEZONE_COPY = _getTimezoneCopy(CHANGING_TOP_COPY);
export const TZ_APP_NOT_SAVED_WARNING_TEXT = (
  <span>
    App's time zone is not set. Click <span className="h_fw-600">"Save Settings"</span> below to set your app's time zone for
    all users.
  </span>
);
export const TZ_ORG_NOT_SAVED_WARNING_TEXT = (
  <span>
    Organization's time zone is not set. Click <span className="h_fw-600">"Save Settings"</span> below to set your
    organization's time zone for all users.
  </span>
);
export const AUTO_SETTING_WARNING_TEXT = <span>If you don't set a time zone, your time zone will be set to UTC.</span>;
